<mf-grid
  #grid
  actionButtonText="{{ showCreateButton ? 'Nueva transferencia' : '' }}"
  (actionButtonClick)="openNewTransferPopup()"
  [apiEndpoint]="apiEndpoint"
  [columns]="columns"
  [hideFilters]="hideFilters"
  [initialFilters]="filters"
  [menuItems]="menuItems" />
